module.exports = __webpack_public_path__ + "img/Energetic Driver.9d647629.svg";